(() => {
  const widget = document.getElementById('mayhem-accessibility');
  if (!widget || widget.dataset.ready) return;
  widget.dataset.ready = 'true';
  const root = document.documentElement;
  const launcher = widget.querySelector('#mayhem-accessibility-launcher');
  const panel = widget.querySelector('dialog');
  const status = widget.querySelector('[role="status"]');
  const key = 'mayhem-accessibility-v1';
  const defaults = { text: '0', contrast: false, motion: false, links: false, font: false, spacing: false };
  let settings = { ...defaults };
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved && typeof saved === 'object') {
      settings.text = ['0', '1', '2'].includes(saved.text) ? saved.text : '0';
      for (const name of ['contrast', 'motion', 'links', 'font', 'spacing']) settings[name] = saved[name] === true;
    }
  } catch {}
  root.style.setProperty('--mayhem-a11y-base', getComputedStyle(root).fontSize);
  const pausedVideos = new Set();
  function apply() {
    root.toggleAttribute('data-mayhem-a11y', Object.entries(settings).some(([name, value]) => name === 'text' ? value !== '0' : value));
    for (const [name, value] of Object.entries(settings)) {
      root.setAttribute(`data-mayhem-a11y-${name}`, String(value));
      const control = widget.querySelector(`[data-a11y-setting="${name}"]`);
      if (name === 'text') control.value = value;
      else control.setAttribute('aria-pressed', String(value));
    }
    if (settings.motion) {
      document.querySelectorAll('video').forEach(video => {
        if (!video.paused) { pausedVideos.add(video); video.pause(); }
      });
    } else {
      pausedVideos.forEach(video => {
        if (video.isConnected && video.autoplay) video.play().catch(() => {});
      });
      pausedVideos.clear();
    }
  }
  function save() {
    apply();
    try { localStorage.setItem(key, JSON.stringify(settings)); } catch {}
    status.textContent = status.dataset.savedMessage;
  }
  widget.querySelectorAll('button[data-a11y-setting]').forEach(button => button.addEventListener('click', () => {
    const name = button.dataset.a11ySetting;
    settings[name] = !settings[name];
    save();
  }));
  widget.querySelector('select').addEventListener('change', event => { settings.text = event.target.value; save(); });
  launcher.addEventListener('click', () => {
    panel.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    widget.querySelector('[data-a11y-close]').focus();
  });
  widget.querySelector('[data-a11y-close]').addEventListener('click', () => panel.close());
  panel.addEventListener('close', () => { launcher.setAttribute('aria-expanded', 'false'); launcher.focus(); });
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const bounds = panel.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) panel.close();
  });
  widget.querySelector('[data-a11y-reset]').addEventListener('click', () => {
    settings = { ...defaults };
    apply();
    try { localStorage.removeItem(key); } catch {}
    status.textContent = status.dataset.resetMessage;
  });
  document.addEventListener('play', event => {
    if (settings.motion && event.target instanceof HTMLVideoElement && event.target.autoplay) {
      pausedVideos.add(event.target);
      event.target.pause();
    }
  }, true);
  apply();
  launcher.hidden = false;
})();
